<section class="messaging-page">
  <header class="messaging-toolbar">
    <div>
      <h1>{{ pageTitle }}</h1>
      <span>{{ pageDescription }}</span>
    </div>
  </header>

  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="stats-grid">
    <article class="stat-card">
      <span>Личные аккаунты</span>
      <strong>{{ accounts.length }}</strong>
    </article>
    <article class="stat-card">
      <span>Готовы к отправке</span>
      <strong>{{ activeAccountsCount }}</strong>
    </article>
    <article class="stat-card">
      <span>Активные боты</span>
      <strong>{{ activeBotsCount }}</strong>
    </article>
    <article class="stat-card">
      <span>Парсеры</span>
      <strong>{{ activeParsersCount }}/{{ parsers.length }}</strong>
    </article>
  </section>

  <section class="list-panel telegram-list-panel" *ngIf="isListMode">
    <div class="panel-tools">
      <div>
        <h2>Подключения Telegram</h2>
        <span>{{ accounts.length }} аккаунтов, {{ bots.length }} ботов, {{ parsers.length }} парсеров</span>
      </div>
      <div class="panel-actions">
        <a class="action-button panel-add-button" routerLink="/dashboard/telegram/accounts/new">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
          <span>Добавить аккаунт</span>
        </a>
        <a class="action-button panel-add-button" routerLink="/dashboard/telegram/bots/new">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
          <span>Добавить бота</span>
        </a>
        <a class="action-button panel-add-button" routerLink="/dashboard/telegram/parsers/new">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
          <span>Добавить парсер</span>
        </a>
      </div>
    </div>

    <section class="auth-panel" *ngIf="authAccount">
      <header>
        <div>
          <strong>Авторизация {{ authAccount.label }}</strong>
          <span>{{ authAccount.user?.displayName || authAccount.user?.username || getUserName(authAccount.userId) }}</span>
        </div>
        <button class="icon-button" type="button" title="Закрыть" aria-label="Закрыть" (click)="cancelAuthorization()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </button>
      </header>
      <div class="auth-grid">
        <label>
          <span>Код Telegram</span>
          <input class="form-control" name="authCode" placeholder="12345" [(ngModel)]="authCode">
        </label>
        <label *ngIf="authPasswordRequired">
          <span>Облачный пароль</span>
          <input class="form-control" type="password" name="authPassword" placeholder="Пароль 2FA" [(ngModel)]="authPassword">
        </label>
      </div>
      <div class="auth-actions">
        <span *ngIf="authCodeInfo">Код отправлен {{ authCodeInfo.isCodeViaApp ? 'в приложение Telegram' : 'по SMS' }}.</span>
        <button class="action-button primary" type="button" (click)="confirmAuthorization()" [disabled]="authConfirming">
          {{ authConfirming ? 'Проверяем...' : 'Подтвердить' }}
        </button>
      </div>
    </section>

    <div class="telegram-columns">
      <section class="telegram-list-section">
        <header class="telegram-section-heading">
          <div>
            <h3>Личные аккаунты</h3>
            <span>{{ activeAccountsCount }} готовы к отправке</span>
          </div>
        </header>

        <div class="empty-state" *ngIf="!loading && accounts.length === 0">Telegram-аккаунты пока не добавлены.</div>

        <div class="telegram-list" *ngIf="accounts.length > 0">
          <article class="telegram-row" *ngFor="let account of accounts; trackBy: trackById">
            <div class="telegram-row-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 21a8 8 0 1 0-16 0"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <div class="telegram-row-main">
              <strong>{{ getAccountTitle(account) }}</strong>
              <span>api_id {{ account.apiId }} • телефон •••• {{ account.phoneLast4 }}</span>
            </div>
            <div class="telegram-row-meta">
              <span>{{ account.sessionStringConfigured ? 'Сессия сохранена' : 'Сессия не задана' }}</span>
              <span>{{ account.apiHashConfigured ? 'api_hash задан' : 'api_hash не задан' }}</span>
            </div>
            <div class="telegram-row-status">
              <span class="status-pill" [class.active]="account.authStatus === 'authorized'" [class.error]="account.authStatus === 'error'">{{ getAuthStatusLabel(account.authStatus) }}</span>
              <small>{{ formatDate(account.lastCheckedAt) }}</small>
            </div>
            <div class="icon-actions">
              <button class="icon-button auth" type="button" (click)="startAuthorization(account)" title="Отправить код авторизации" aria-label="Отправить код авторизации" [disabled]="authSendingCode">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 12a9 9 0 1 1-9-9"/><path d="M21 3v6h-6"/><path d="M21 3 12 12"/></svg>
              </button>
              <a class="icon-button edit" [routerLink]="['/dashboard/telegram/accounts', account.id, 'edit']" title="Редактировать" aria-label="Редактировать">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
              </a>
              <button class="icon-button delete" type="button" (click)="deleteAccount(account)" title="Удалить" aria-label="Удалить">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
              </button>
            </div>
          </article>
        </div>
      </section>

      <section class="telegram-list-section">
        <header class="telegram-section-heading">
          <div>
            <h3>Telegram-боты</h3>
            <span>{{ activeBotsCount }} активны</span>
          </div>
        </header>

        <div class="empty-state" *ngIf="!loading && bots.length === 0">Telegram-боты пока не добавлены.</div>

        <div class="telegram-list" *ngIf="bots.length > 0">
          <article class="telegram-row bot-row" *ngFor="let bot of bots; trackBy: trackById">
            <div class="telegram-row-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8V4H8"/><rect x="4" y="8" width="16" height="12" rx="2"/><path d="M2 14h2"/><path d="M20 14h2"/><path d="M15 13v2"/><path d="M9 13v2"/></svg>
            </div>
            <div class="telegram-row-main">
              <strong>{{ bot.label }}</strong>
              <span>{{ bot.username ? '@' + bot.username : 'username не указан' }}</span>
            </div>
            <div class="telegram-row-meta">
              <span>{{ bot.tokenConfigured ? 'Token сохранен' : 'Token не задан' }}</span>
              <span>Админов {{ bot.adminTelegramIds.length }}</span>
            </div>
            <div class="telegram-row-status">
              <span class="status-pill" [class.active]="bot.isActive" [class.error]="!bot.isActive">{{ bot.isActive ? 'Активен' : 'Выключен' }}</span>
              <small>{{ bot.adminTelegramIds.join(', ') || 'Админы не указаны' }}</small>
            </div>
            <div class="icon-actions">
              <a class="icon-button edit" [routerLink]="['/dashboard/telegram/bots', bot.id, 'edit']" title="Редактировать" aria-label="Редактировать">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
              </a>
              <button class="icon-button delete" type="button" (click)="deleteBot(bot)" title="Удалить" aria-label="Удалить">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
              </button>
            </div>
          </article>
        </div>
      </section>

      <section class="telegram-list-section parser-list-section">
        <header class="telegram-section-heading">
          <div>
            <h3>Парсеры каналов</h3>
            <span>{{ activeParsersCount }} запущены</span>
          </div>
        </header>

        <div class="empty-state" *ngIf="!loading && parsers.length === 0">Telegram-парсеры пока не добавлены.</div>

        <div class="telegram-list" *ngIf="parsers.length > 0">
          <article class="telegram-row parser-row" *ngFor="let parser of parsers; trackBy: trackById">
            <div class="telegram-row-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16"/><path d="M4 12h10"/><path d="M4 19h7"/><path d="m17 15 3 3-3 3"/><path d="M14 18h6"/></svg>
            </div>
            <div class="telegram-row-main">
              <strong>{{ parser.label }}</strong>
              <span>{{ getParserAccountTitle(parser) }}</span>
            </div>
            <div class="telegram-row-meta">
              <span>{{ parser.sourceChatIds.length }} источников</span>
              <span>{{ parser.keywords.length }} слов</span>
              <span>{{ formatParserChannels(parser) }}</span>
            </div>
            <div class="telegram-row-status">
              <span class="status-pill" [class.active]="parser.isActive" [class.error]="parser.lastError">{{ parser.isActive ? 'Запущен' : 'Остановлен' }}</span>
              <small>{{ parser.lastError || ('Проверка ' + formatDate(parser.lastCheckedAt)) }}</small>
            </div>
            <div class="telegram-row-meta parser-metrics">
              <span>Найдено {{ parser.matchedCount }}</span>
              <span>Переслано {{ parser.forwardedCount }}</span>
            </div>
            <div class="icon-actions">
              <button class="icon-button auth" type="button" (click)="toggleParser(parser)" [disabled]="togglingParserIds[parser.id]" [title]="parser.isActive ? 'Остановить' : 'Запустить'" [attr.aria-label]="parser.isActive ? 'Остановить парсер' : 'Запустить парсер'">
                <svg *ngIf="!parser.isActive" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7Z"/></svg>
                <svg *ngIf="parser.isActive" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14"/><path d="M16 5v14"/></svg>
              </button>
              <a class="icon-button edit" [routerLink]="['/dashboard/telegram/parsers', parser.id, 'edit']" title="Редактировать" aria-label="Редактировать">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
              </a>
              <button class="icon-button delete" type="button" (click)="deleteParser(parser)" title="Удалить" aria-label="Удалить">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
              </button>
            </div>
          </article>
        </div>
      </section>
    </div>
  </section>

  <section class="telegram-editor" *ngIf="isAccountEditorMode">
    <form class="editor-layout" (ngSubmit)="saveAccount()">
      <div class="editor-main">
        <section class="form-panel">
          <h2>{{ formTitle }}</h2>
          <div class="form-grid">
            <label>
              <span>Пользователь</span>
              <select class="form-control" name="userId" [(ngModel)]="formData.userId">
                <option *ngFor="let user of context.users; trackBy: trackById" [value]="user.id">{{ user.displayName || user.username }}</option>
              </select>
            </label>

            <label>
              <span>Название</span>
              <input class="form-control" name="label" placeholder="GRAM" [(ngModel)]="formData.label">
            </label>

            <label>
              <span>api_id</span>
              <input class="form-control" type="number" name="apiId" [(ngModel)]="formData.apiId">
            </label>

            <label>
              <span>api_hash</span>
              <input class="form-control" name="apiHash" [placeholder]="editingAccount ? 'Оставьте пустым, если не меняется' : 'Telegram api_hash'" [(ngModel)]="formData.apiHash">
            </label>

            <label>
              <span>Телефон</span>
              <input class="form-control" name="phone" [placeholder]="editingAccount ? 'Оставьте пустым, если не меняется' : '+7 900 000-00-00'" [(ngModel)]="formData.phone">
            </label>

            <label>
              <span>Статус</span>
              <select class="form-control" name="authStatus" [(ngModel)]="formData.authStatus">
                <option *ngFor="let status of authStatuses" [value]="status.value">{{ status.label }}</option>
              </select>
            </label>
          </div>
        </section>

        <section class="auth-panel" *ngIf="authAccount">
          <header>
            <div>
              <strong>Авторизация {{ authAccount.label }}</strong>
              <span>{{ authAccount.user?.displayName || authAccount.user?.username || getUserName(authAccount.userId) }}</span>
            </div>
            <button class="icon-button" type="button" title="Закрыть" aria-label="Закрыть" (click)="cancelAuthorization()">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
            </button>
          </header>
          <div class="auth-grid">
            <label>
              <span>Код Telegram</span>
              <input class="form-control" name="authCodeEditor" placeholder="12345" [(ngModel)]="authCode">
            </label>
            <label *ngIf="authPasswordRequired">
              <span>Облачный пароль</span>
              <input class="form-control" type="password" name="authPasswordEditor" placeholder="Пароль 2FA" [(ngModel)]="authPassword">
            </label>
          </div>
          <div class="auth-actions">
            <span *ngIf="authCodeInfo">Код отправлен {{ authCodeInfo.isCodeViaApp ? 'в приложение Telegram' : 'по SMS' }}.</span>
            <button class="action-button primary" type="button" (click)="confirmAuthorization()" [disabled]="authConfirming">
              {{ authConfirming ? 'Проверяем...' : 'Подтвердить' }}
            </button>
          </div>
        </section>
      </div>

      <aside class="editor-side">
        <section class="form-panel actions-panel">
          <h2>Действия</h2>
          <button class="action-button primary" type="submit" [disabled]="saving">{{ accountSubmitLabel }}</button>
          <ng-container *ngIf="editingAccount as account">
            <button class="action-button ghost" type="button" (click)="startAuthorization(account)" [disabled]="authSendingCode">
              {{ authSendingCode ? 'Отправляем...' : 'Отправить код' }}
            </button>
            <button class="action-button danger" type="button" [disabled]="saving" (click)="deleteAccount(account)">Удалить аккаунт</button>
          </ng-container>
          <a class="action-button ghost" routerLink="/dashboard/telegram">Назад к списку</a>
        </section>
      </aside>
    </form>
  </section>

  <section class="telegram-editor" *ngIf="isBotEditorMode">
    <form class="editor-layout" (ngSubmit)="saveBot()">
      <div class="editor-main">
        <section class="form-panel">
          <h2>{{ botFormTitle }}</h2>
          <div class="form-grid">
            <label>
              <span>Название</span>
              <input class="form-control" name="botLabel" placeholder="IcePass Bot" [(ngModel)]="botFormData.label">
            </label>

            <label>
              <span>Username</span>
              <input class="form-control" name="botUsername" placeholder="@icepass_bot" [(ngModel)]="botFormData.username">
            </label>

            <label class="wide">
              <span>Bot token</span>
              <input class="form-control" name="botToken" [placeholder]="editingBot?.tokenConfigured ? 'Оставьте пустым, если не меняется' : '123456:ABC...'" [(ngModel)]="botFormData.token">
            </label>

            <label class="wide">
              <span>Telegram ID администраторов</span>
              <textarea class="form-control textarea compact" name="botAdminIds" rows="3" placeholder="399439578" [(ngModel)]="botAdminIdsText"></textarea>
            </label>

            <label class="toggle-row">
              <input type="checkbox" name="botIsActive" [(ngModel)]="botFormData.isActive">
              <span>{{ botFormData.isActive ? 'Бот активен' : 'Бот выключен' }}</span>
            </label>
          </div>
        </section>
      </div>

      <aside class="editor-side">
        <section class="form-panel actions-panel">
          <h2>Действия</h2>
          <button class="action-button primary" type="submit" [disabled]="savingBot">{{ botSubmitLabel }}</button>
          <ng-container *ngIf="editingBot as bot">
            <button class="action-button danger" type="button" [disabled]="savingBot" (click)="deleteBot(bot)">Удалить бота</button>
          </ng-container>
          <a class="action-button ghost" routerLink="/dashboard/telegram">Назад к списку</a>
        </section>
      </aside>
    </form>
  </section>

  <section class="telegram-editor" *ngIf="isParserEditorMode">
    <form class="editor-layout" (ngSubmit)="saveParser()">
      <div class="editor-main">
        <section class="form-panel">
          <h2>{{ parserFormTitle }}</h2>
          <div class="form-grid">
            <label>
              <span>Название</span>
              <input class="form-control" name="parserLabel" placeholder="Билеты КХЛ" [(ngModel)]="parserFormData.label">
            </label>

            <label>
              <span>Telegram-аккаунт</span>
              <select class="form-control" name="parserTelegramAccount" [(ngModel)]="parserFormData.telegramAccountId">
                <option value="">Выберите аккаунт</option>
                <option *ngFor="let account of accounts; trackBy: trackById" [value]="account.id" [disabled]="account.authStatus !== 'authorized' || !account.sessionStringConfigured">{{ getAccountTitle(account) }}</option>
              </select>
            </label>

            <section class="source-channel-editor wide">
              <header>
                <div>
                  <span>Каналы-источники</span>
                  <small>{{ parserSourceChannels.length }} источников</small>
                </div>
                <button class="action-button ghost compact-button" type="button" (click)="addParserSourceChannel()">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
                  <span>Добавить источник</span>
                </button>
              </header>

              <div class="source-channel-list" *ngIf="parserSourceChannels.length > 0">
                <article class="source-channel-row" *ngFor="let source of parserSourceChannels; trackBy: trackByFormId" [class.editing]="source.isEditing">
                  <ng-container *ngIf="!source.isEditing; else sourceEditor">
                    <div class="source-channel-main">
                      <strong>{{ getParserSourceChannelTitle(source) }}</strong>
                      <span>{{ source.chatId }}</span>
                    </div>
                    <div class="icon-actions">
                      <button class="icon-button edit" type="button" title="Редактировать источник" aria-label="Редактировать источник" (click)="editParserSourceChannel(source)">
                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
                      </button>
                      <button class="icon-button delete" type="button" title="Удалить источник" aria-label="Удалить источник" (click)="removeParserSourceChannel(source)">
                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #sourceEditor>
                    <label>
                      <span>Канал</span>
                      <input class="form-control" [name]="'parserSourceChatId' + source.formId" placeholder="-1001284634752 или @channel" [(ngModel)]="source.draftChatId">
                    </label>
                    <label>
                      <span>Комментарий</span>
                      <input class="form-control" [name]="'parserSourceLabel' + source.formId" placeholder="ХК «Автомобилист»" [(ngModel)]="source.draftLabel">
                    </label>
                    <div class="icon-actions">
                      <button class="icon-button auth" type="button" title="Готово" aria-label="Готово" (click)="applyParserSourceChannel(source)">
                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m20 6-11 11-5-5"/></svg>
                      </button>
                      <button class="icon-button delete" type="button" title="Отменить" aria-label="Отменить" (click)="cancelParserSourceChannelEdit(source)">
                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                      </button>
                    </div>
                  </ng-template>
                </article>
              </div>
              <div class="empty-state" *ngIf="parserSourceChannels.length === 0">Каналы-источники пока не добавлены.</div>
            </section>

            <label>
              <span>Целевой канал</span>
              <input class="form-control" name="parserTarget" placeholder="-1002356062714 или @channel" [(ngModel)]="parserFormData.targetChatId">
            </label>

            <label>
              <span>Интервал проверки, сек</span>
              <input class="form-control" type="number" min="5" max="3600" name="parserPollInterval" [(ngModel)]="parserFormData.pollIntervalSeconds">
            </label>

            <label>
              <span>Глубина истории</span>
              <input class="form-control" type="number" min="1" max="200" name="parserHistoryLimit" [(ngModel)]="parserFormData.historyLimit">
            </label>

            <label class="wide">
              <span>Ключевые слова</span>
              <textarea class="form-control textarea compact" name="parserKeywords" rows="4" placeholder="билет&#10;билеты" [(ngModel)]="parserKeywordsText"></textarea>
            </label>

            <label class="toggle-row">
              <input type="checkbox" name="parserIsActive" [(ngModel)]="parserFormData.isActive">
              <span>{{ parserFormData.isActive ? 'Запустить после сохранения' : 'Сохранить остановленным' }}</span>
            </label>
          </div>
        </section>
      </div>

      <aside class="editor-side">
        <section class="form-panel actions-panel">
          <h2>Действия</h2>
          <button class="action-button primary" type="submit" [disabled]="savingParser">{{ parserSubmitLabel }}</button>
          <ng-container *ngIf="editingParser as parser">
            <button class="action-button ghost" type="button" [disabled]="savingParser || togglingParserIds[parser.id]" (click)="toggleParser(parser)">
              {{ parser.isActive ? 'Остановить парсер' : 'Запустить парсер' }}
            </button>
            <button class="action-button danger" type="button" [disabled]="savingParser" (click)="deleteParser(parser)">Удалить парсер</button>
          </ng-container>
          <a class="action-button ghost" routerLink="/dashboard/telegram">Назад к списку</a>
        </section>
      </aside>
    </form>
  </section>
</section>
